import {useEffect, useRef} from "react";

import {RequestState} from "@pg-mono/request-state";

import {IPropertyListProperty} from "../../../property/types/PropertyListProperty";
import {IAmplitudePropertyListMainOffer} from "../../../tracking/amplitude/get_amplitude_property_list_item";
import {AmplitudePropertyListView, trackAmplitudePropertyViewItemList} from "../../../tracking/amplitude/track_amplitude_property_view_item_list";
import {useElementViewportShowingUpStatus} from "../../../tracking/hooks/use_element_viewport_showing_up_status";

interface IUseOfferDetailPropertyListAmplitudeViewItemListTrackingParams {
    offer: IAmplitudePropertyListMainOffer;
    offerId: number;
    properties: IPropertyListProperty[];
    itemListName: string;
    listView: AmplitudePropertyListView;
    queryKey: string;
    requestState: RequestState;
}

/**
 * DSA-A-71 view_item_list for the "Mieszkania w inwestycji" list on the offer (investment) page.
 *
 * Pass the returned containerId as `data-id` on the element that should trigger the first (visibility based) hit.
 */
export const useOfferDetailPropertyListAmplitudeViewItemListTracking = (params: IUseOfferDetailPropertyListAmplitudeViewItemListTrackingParams) => {
    const {offer, offerId, properties, itemListName, listView, queryKey, requestState} = params;

    const {containerId, isWaitingForElement} = useElementViewportShowingUpStatus({useVisibilityTracking: true});

    const propertyIdsKey = properties.map((property) => property.id).join(",");
    const contextKey = `${offerId}|${queryKey}|${propertyIdsKey}`;

    const contextRef = useRef<{key: string; itemListId: string; seq: number} | null>(null);

    if (contextRef.current?.key !== contextKey) {
        contextRef.current = {
            key: contextKey,
            // the DSA-A-37 fallback shape has a one second resolution, so seq - not the id - is what keeps two
            // lists minted within the same second apart for the dedupe below
            seq: (contextRef.current?.seq ?? 0) + 1,
            itemListId: `${Math.floor(Date.now() / 1000)}_investment_apartments_${offerId}`
        };
    }

    const {itemListId, seq} = contextRef.current;

    const prevTrackedKeyRef = useRef<string | null>(null);

    useEffect(() => {
        if (isWaitingForElement || requestState !== RequestState.Success || properties.length === 0) {
            return;
        }

        const trackedKey = `${seq}|${listView}`;

        if (prevTrackedKeyRef.current === trackedKey) {
            return;
        }

        prevTrackedKeyRef.current = trackedKey;

        trackAmplitudePropertyViewItemList({
            offer,
            properties,
            itemListId,
            itemListName,
            location: "investment_page",
            listView
        });
    }, [isWaitingForElement, requestState, seq, itemListId, listView, properties, offer, itemListName]);

    return {containerId, itemListId};
};
import {useEffect, useRef} from "react";

import {RequestState} from "@pg-mono/request-state";

import {IPropertyListProperty} from "../../../property/types/PropertyListProperty";
import {IAmplitudePropertyListMainOffer} from "../../../tracking/amplitude/get_amplitude_property_list_item";
import {AmplitudePropertyListView, trackAmplitudePropertyViewItemList} from "../../../tracking/amplitude/track_amplitude_property_view_item_list";
import {useElementViewportShowingUpStatus} from "../../../tracking/hooks/use_element_viewport_showing_up_status";

interface IUseOfferDetailPropertyListAmplitudeViewItemListTrackingParams {
    offer: IAmplitudePropertyListMainOffer;
    offerId: number;
    properties: IPropertyListProperty[];
    itemListName: string;
    listView: AmplitudePropertyListView;
    queryKey: string;
    requestState: RequestState;
}

/**
 * DSA-A-71 view_item_list for the "Mieszkania w inwestycji" list on the offer (investment) page.
 *
 * Pass the returned containerId as `data-id` on the element that should trigger the first (visibility based) hit.
 */
export const useOfferDetailPropertyListAmplitudeViewItemListTracking = (params: IUseOfferDetailPropertyListAmplitudeViewItemListTrackingParams) => {
    const {offer, offerId, properties, itemListName, listView, queryKey, requestState} = params;

    const {containerId, isWaitingForElement} = useElementViewportShowingUpStatus({useVisibilityTracking: true});

    const propertyIdsKey = properties.map((property) => property.id).join(",");
    const contextKey = `${offerId}|${queryKey}|${propertyIdsKey}`;

    const contextRef = useRef<{key: string; itemListId: string; seq: number} | null>(null);

    if (contextRef.current?.key !== contextKey) {
        contextRef.current = {
            key: contextKey,
            // the DSA-A-37 fallback shape has a one second resolution, so seq - not the id - is what keeps two
            // lists minted within the same second apart for the dedupe below
            seq: (contextRef.current?.seq ?? 0) + 1,
            itemListId: `${Math.floor(Date.now() / 1000)}_investment_apartments_${offerId}`
        };
    }

    const {itemListId, seq} = contextRef.current;

    const prevTrackedKeyRef = useRef<string | null>(null);

    useEffect(() => {
        if (isWaitingForElement || requestState !== RequestState.Success || properties.length === 0) {
            return;
        }

        const trackedKey = `${seq}|${listView}`;

        if (prevTrackedKeyRef.current === trackedKey) {
            return;
        }

        prevTrackedKeyRef.current = trackedKey;

        trackAmplitudePropertyViewItemList({
            offer,
            properties,
            itemListId,
            itemListName,
            location: "investment_page",
            listView
        });
    }, [isWaitingForElement, requestState, seq, itemListId, listView, properties, offer, itemListName]);

    return {containerId, itemListId};
};
